import { render, staticRenderFns } from "./CustomizeWidgetsModal.vue?vue&type=template&id=c31ff4e2"
import script from "./CustomizeWidgetsModal.vue?vue&type=script&lang=ts"
export * from "./CustomizeWidgetsModal.vue?vue&type=script&lang=ts"
import style0 from "./CustomizeWidgetsModal.vue?vue&type=style&index=0&id=c31ff4e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,CustomizeWidgetsModalRow: require('/app/components/RepoOverview/CustomizeWidgets/CustomizeWidgetsModalRow.vue').default,EmptyState: require('/app/components/Common/EmptyState.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZModal: require('/app/components/zeal/ZModal/ZModal.vue').default})
